<template>
  <div class="container">
    <TrfHeader pageTitle="eLegalize"/>

    <ELegalizeModalListaProcessos
      ref="modalListaProcessos"
      :titulo="modalListaProcessos.titulo"
      :isAtivo="modalListaProcessos.isAtivo"
      :filtro="modalListaProcessos.filtro"
      :listaDepartamentos="listaDepartamentos"
      :listaResponsaveis="responsavelOptions"
      @close="fecharModalListaProcessos"
    ></ELegalizeModalListaProcessos>
    
    <TrfSimpleModal :titulo="tituloModalDetalhesProcessos" :isAtivo="isModalDetalhesProcessosAtivo" :isModalPersonalizado="true" @close="doFecharModalDetalhesProcessos">
      <TrfDetalhesProcessos v-if="isModalDetalhesProcessosAtivo" :processo="detalhesProcessos" :listaResponsaveis="responsavelOptions" @anexos-alterados="recarregarProcesso"></TrfDetalhesProcessos>
    </TrfSimpleModal>

    <TrfSimpleModal :titulo="tituloModalDetalhesFase" :isAtivo="isModalDetalhesFaseAtivo" :isModalPersonalizado="true" @close="doFecharModalDetalhesFase">
      <TrfDetalhesProcessos v-if="isModalDetalhesFaseAtivo" :processo="detalhesFase" :listaResponsaveis="responsavelOptions" :is-fase="true" :fase-id="faseIdSelecionada" @anexos-alterados="recarregarProcesso"></TrfDetalhesProcessos>
    </TrfSimpleModal>

    <TrfFilter
      :configuration="filterConfig"
      @update:query-string="setQuery"
    ></TrfFilter>

    <div class="is-flex is-justify-content-center">
      <div class="columns is-2 is-multiline is-inline-flex is-justify-content-flex-start">
        <TrfDashboardTotalizadoresCards :totalizadores="totalizadores"/>
      </div>
    </div>
    
    <hr class="mb-6"/>

    <div class="columns is-align-items-flex-end">
      <div class="column is-2-desktop is-12-mobile btn-container">
        <div v-if="(permissoesLegalize && permissoesLegalize.Criar) || isSuperAdm || true">
          <!--Corrigir condições de permissão para criar-->
          <TrfDropdownButton
            nome="Novo processo"
            classIconEsquerda="mdi-plus"
            :btnOptions="opcoesNovoProcesso"
          />
        </div>
      </div>
    </div>

    <TrfSimpleModal v-e2e="'pausar-historico-modal'" id="pausar-historico-modal" :titulo="tituloModalPausar" :isAtivo="isModalPausarAtivo" @close="fecharModalPausar" :isModalPersonalizado="false">
      <div class="px-2 py-1">
        <TrfParalisarFormComponent ref="paralisarForm" :tarefa="itemEmAcesso" @done:action="async () => {await processoParalisadoCallBack()}" @error:save="() => setBtnModalLoading(false)"></TrfParalisarFormComponent>
      </div>
      <template #slot-footer>
        <TrfButton nome="Confirmar" type="button" classCor="is-primary" :is-btn-loading="isBtnModalLoading" @click="doParalisarProcesso" v-e2e="'modal-paralisar-btn-confirmar'"></TrfButton>
        <TrfButton nome="Cancelar" type="button" @click="fecharModalPausar" v-e2e="'modal-paralisar-btn-cancelar'"></TrfButton>
      </template>
    </TrfSimpleModal>

    <TrfSimpleModal v-e2e="'continuar-historico-modal'" id="continuar-historico-modal" :titulo="tituloModalContinuar" :isAtivo="isModalContinuarAtivo" @close="fecharModalContinuar" :isModalPersonalizado="false">
      <div class="px-2 py-1">
        <p>Deseja continuar  {{`${itemEmAcesso?.isFase? 'esta fase' : itemEmAcesso?.isProcesso ? 'este negócio' : 'esta tarefa'}` }}?</p>
        <br/>
        <p>
          <strong>Atenção:</strong> Ao clicar em confirmar, {{`${itemEmAcesso?.isFase? 'a fase' : itemEmAcesso?.isProcesso ? 'o negócio' : 'a tarefa'}` }} será retirad{{ `${itemEmAcesso?.isProcesso ? 'o' : 'a'}`}} do status "Paralisad{{ `${itemEmAcesso?.isProcesso ? 'o' : 'a'}`}}" e retornará para o status original.
        </p>
      </div>
      <template #slot-footer>
        <TrfButton nome="Confirmar" type="button" classCor="is-primary" :is-btn-loading="isBtnModalLoading" @click="doContinuarProcesso" v-e2e="'modal-continuar-btn-confirmar'"></TrfButton>
        <TrfButton nome="Cancelar" type="button" @click="fecharModalContinuar" v-e2e="'modal-continuar-btn-confirmar'"></TrfButton>
      </template>
    </TrfSimpleModal>

    <div class="pt-2">
      <TrfTabela
        :tipoTabela="'tabela-processos'"
        :dataConfig="dataSourceProcessos"
        :data="processosAsTableRows"
        :quantidadeDeItems="totalTabela"
        :nextPage="nextPagina"
        :nextLimit="nextLimite"
        :isButtonMoreHidden="hideButtons"
        :showDropdownOptions="true"
        :showButtonsDefault="false"
        :isButtonsDisplayed="true"
        :showAlterarVencimento="true"
        :dataStatus="statusTabela"
        :showReabrir="false"
        @update:pagina="(pagina) => updatePagina(pagina)"
        @update:limite="(limite) => updateLimite(limite)"
        :paginaSelecionada="paginaTabela"
        :limiteAtual="limiteTabela"
        textoNadaEncontrado="Nenhum processo foi encontrado."
        tituloExclusao="Excluir negócio"
        :textoExclusao="mensagemExclusaoDeAcordoComTipoDeProcesso"
        :shouldIgnorePreDelete="false"
        :showGlobalLoader="showGlobalLoader"
        :showEdit="this.permissoesTarefas.Editar"
        :showEditarAvulsas="false"
        :showConcluir="true"
        :showDelete="hasPermissaoExcluir()"
        :showTransferir="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
        :showEditarVencimento="false"
        :showEnviarFormulario="true"
        :isMultipleSelection="true"
        :showParalisar="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
        :showVisualizar="true"
        @duploClick="($event) => doAbrirModalTimelineProcesso($event)"
        @trfTableItemSelected="($event) => setSelecaoTabela($event)"
        @trf-tabela-paralisar="paralisarProcesso"
        @trf-tabela-continuar="continuarProcesso"
        @trf-tabela-enviar-formulario="doAbrirModalEnvioDoFormulario($event, true)"
        @trf-tabela-visualizar="doNavegarParaVisualizacaoDoFormulario($event)"
        @trf-tabela-alterar-vencimento="doAbrirModalAlterarVencimento"
        :hasSlotLine="true"
        :isToggleble="true"
        togglebleItem="fases"
        tituloModalConclusao="Concluir negócio"
        :checkboxClass="'is-hidden'"
      >
        <template #slotLine="{ item }">
          <tr v-if="item.fases != null" class="is-togglable-row" style="background: #fff !important">
            <td colspan="2" class="p-0 m-0"></td>
            <td colspan="7" class="p-0 m-0">
              <TrfTabela
                :tipoTabela="'tabela-fases'"
                :containerClass="'tabela-fase-branca'"
                :isStriped="false"
                :dataConfig="getDataSourceFase(getFasesAsTableRow(item.id, item.fases))"
                :data="getFasesAsTableRow(item.id, item.fases)"
                dataStatus=""
                :paginacao="false"
                :quantidadeDeItems="item.fases.length"
                @update:pagina="(pagina) => updatePagina(pagina)"
                @duploClick="(fase) => doAbrirModalTimelineFase(item, fase)"
                :showDropdownOptions="true"
                :isButtonsDisplayed="true"
                :showButtonsDefault="true"
                :showReabrir="isSuperAdm || isOperadorAdmin || permissoesTarefas.Excluir"
                :showConcluir="true"
                :showDelete="false"
                :showParalisar="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
                @trf-tabela-paralisar="paralisarProcesso"
                @trf-tabela-continuar="continuarProcesso"
                @trf-tabela-detalhes-fase="doAbrirModalTimelineFase(item, $event)"
                :showTransferir="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Editar || this.isSuperAdm"
                textoNadaEncontrado="Nenhuma fase foi encontrada."
                :showEdit="false"
                :isMultipleSelection="false"
                :isSelectable="false"
                tituloModalConclusao="Concluir fase"
              />
            </td>
          </tr>
          <tr v-if="item.fases != null"></tr>
        </template>
      </TrfTabela>
    </div>
  </div>

  <TrfModal
    titulo="Transferir responsável"
    idModal="modal-transferencia-responsavel"
    :isModalActive="isModalTransferenciaAtivo"
    :isBtnLoading="loadingConfirmarTransferencia"
    btnSaveName="Confirmar"
    @save="async (event) => await transferirResponsavel(event)"
    @close="fecharModalTransferirResponsavel"
  >
    <TrfFromTransferenciaResponsavel 
      ref="formTransferenciaResponsavel"
      @update:form-data="(newValue) => montarObjetoTransferenciaResponsavelTarefa(newValue)" 
      :show-title="false" 
      :show-buttons="false" 
      :itemEdicao="objetoTransferenciaResponsavel"
      :departamentos="listaDepartamentos"
    />
  </TrfModal>

  <TrfSimpleModal
    :titulo="modalFormulario.titulo"
    :isAtivo="modalFormulario.isAtivo"
    :isFecharComBackground="false"
    idModal="modal-processo"
    :isModalPersonalizado="true"
    :isScrollPersonalizado="true"
    @close="doFecharModalProcesso"
  >
    <ELegalizeCadastroProcesso
      :show-title="false"
      :show-buttons="false"
      :showMaisAcoesSocios="true"
      ref="eLegalizeForm"
      @elegalize-configuracao-modal-socio="setConfiguracaoModal"
    ></ELegalizeCadastroProcesso>

    <template #slot-footer>
      <div class="buttons">
        <TrfButton
          @click="modalFormulario.acaoConfirma"
          :nome="modalFormulario.labelConfirma"
          classCor="is-primary"
          id="btn-cadastrar-processo"
          :isBtnLoading="modalFormulario.isLoading"
        />
        <TrfButton
          @click="modalFormulario.acaoCancela"
          nome="Cancelar"
          id="btn-cancelar-cadastro-processo"
          :disabled="modalFormulario.isLoading"
        />
      </div>
    </template>
  </TrfSimpleModal>

  <TrfSimpleModal
    :titulo="configsModalEnvioDoFormulario.titulo"
    :isAtivo="configsModalEnvioDoFormulario.isModalEnvioDoFormularioAtivo"
    :isFecharComBackground="false"
    idModal="modal-envio-formulario"
    :isModalPersonalizado="true"
    @close="doFecharModalEnvioDoFormulario"
  >
    <div>
      <p v-html="this.getTextoParaModalDeEnvio()"></p>

      <TrfSelect
        v-if="!isReenvio"
        v-e2e="'select-template-envio-formulario'"
        class="mt-5"
        :options="templateFormularioAsOptionList"
        :required="true"
        label="Selecione o formulário abaixo e confirme o envio."
        idSelect="select-template-envio"
        @valueSelect="setTemplateSelecionadoEnvio"
        placeholder="Selecione"
        ref="selectTemplateEnvio"
        :canClear="false"
        :disabled="loadingTemplatesFormulario"
        :loadingData="loadingTemplatesFormulario">
      </TrfSelect>
      <p v-if="isTemplateSelecionadoTouched && !templateSelecionadoEnvio" class="has-text-danger error-message">
        Selecione um formulário para prosseguir.
      </p>
    </div>

    <template #slot-footer>
      <div class="buttons">
        <TrfButton
            @click="doEnviarFormulario"
            :nome="configsModalEnvioDoFormulario.labelConfirma"
            classCor="is-primary"
            id="btn-enviar-formulario"
            :isBtnLoading="configsModalEnvioDoFormulario.isBtnLoading"
          />
          <TrfButton
            @click="doFecharModalEnvioDoFormulario"
            nome="Não"
            id="btn-cancelar-envio-formulario"
            :disabled="configsModalEnvioDoFormulario.isBtnLoading"
          />
      </div>
    </template>
  </TrfSimpleModal>

  <TrfSimpleModal
    titulo="Reenviar formulário"
    :isAtivo="modalReenvioComAjustes.isAtivo"
    :isFecharComBackground="false"
    :isModalPersonalizado="true"
    idModal="modal-reenvio-formulario-com-ajustes"
    @close="doFecharModalReenvioComAjustes"
  >
    <div>
      <p v-if="hasTokenIntegracaoWhatsapp && processoParaEnvio.pessoaContatoWpp">
        Confirma o reenvio do formulário por e-mail e WhatsApp para a pessoa de contato da abertura do negócio <b>{{processoParaEnvio.nomeNegocio}}</b>?
      </p>

      <p v-else>
        Confirma o reenvio do formulário por e-mail para a pessoa de contato da abertura do negócio <b>{{processoParaEnvio.nomeNegocio}}</b>?
      </p>

      <br><br>
      <b>
        Se houver necessidade de ajustes nas informações preenchidas anteriormente, digite abaixo as instruções para o seu cliente, e elas serão exibidas no formulário reenviado.
      </b>

      <TrfToolbarTextEditor
        v-if="modalReenvioComAjustes.isAtivo"
        :tipLabel="tipLabelReenvio"
        :maxlength="modalReenvioComAjustes.maxlength"
        @changeText="doChangeAjustesText"
        ref="modalReenvioComAjustesText"
      ></TrfToolbarTextEditor>

      <p v-if="hasTokenIntegracaoWhatsapp && processoParaEnvio.pessoaContatoWpp">
        <strong>Atenção:</strong> A notificação de revisão será enviada por WhatsApp com o conteúdo digitado neste modal, porém sem os estilos de texto aplicados, devido às limitações da plataforma quanto à formatação avançada.
      </p>
    </div>
    <template #slot-footer>
      <div class="buttons">
        <TrfButton
            @click="doEnviarFormularioComAjustes"
            classCor="is-primary"
            nome="Reenviar"
            :isBtnLoading="modalReenvioComAjustes.isLoading"
          />
          <TrfButton
            @click="doFecharModalReenvioComAjustes"
            nome="Cancelar"
            :disabled="modalReenvioComAjustes.isLoading"
          />
      </div>
    </template>
  </TrfSimpleModal>
  <TrfModalAlterarData 
    :isActive="isAlterarDataActive"
    :item="itemAlterarData"
    @trf-modal-alterar-data-closed="doFecharModalAlterarVencimento"
    @trf-modal-alterar-data-success="doRecarregarListagemAlteracaoVencimento"
  >
  </TrfModalAlterarData>

</template>

<script>
import { toastUtils } from '../../util/toast.utils';
import { pessoaLogada } from '../../stateManagement/pessoaLogada.js';
import { statusEnum } from '../../enums/statusEnum.js';
import { acessoUtils } from '../../util/acesso.utils';
import { defineAsyncComponent } from 'vue';
import { camposEnderecoStore } from '../../stateManagement/camposEndereco';
import { camposSocioStore } from '../../stateManagement/camposSocio';
import { routerUtils } from '../../util/router.utils.js';
import { ConfigFiltro } from '../../components/Filter/models/configFiltro.model';
import { defaultButtonFiltrar, defaultButtonSelectorIntervalField, defaultCheckboxFieldsStatusFilter, defaultIlikeTextField, defaultPeriodoDataConclusaoField, defaultSelectResponsavelField } from '../../components/Filter/config/filterDefaultConfig';
import { clearFilter, clearInvalidIntervals } from '../../components/Filter/utils/filter.utils';
import ProcessoElegalize from './CadastroDeProcessos/Models/processo-elegalize.model.js';
import { statusTarefas } from '../../util/statusTarefas.utils.js';
import { configuracoesStore } from "../../stateManagement/configuracoes.js";
import { TipoDeProcessoEnum } from './enums/legalize.enum.js';
import { tipoFormularioEnum } from '../../enums/tipoFormularioEnum.js';

// Dicionário
const TITULO_MODAL_CADASTRAR = "Cadastro do processo";
const CONFIRMAR_MODAL_CADASTRAR = "Cadastrar";

const TITULO_MODAL_EDITAR = "Editar processo";
const CONFIRMAR_MODAL_EDITAR = "Editar";

export default {
  name: 'ELegalize',
  components: {
    TrfModal: defineAsyncComponent(() => import("../../components/Modal/index.vue")),
    TrfHeader: defineAsyncComponent(() => import('../../components/Header/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../components/Button/index.vue')),
    TrfTabela: defineAsyncComponent(() => import('../../components/Table/index.vue')),
    TrfSimpleModal: defineAsyncComponent(() => import('../../components/Modal/TrfSimpleModal.vue')),
    ELegalizeCadastroProcesso: defineAsyncComponent(() => import('./CadastroDeProcessos/index.vue')),
    TrfFromTransferenciaResponsavel: defineAsyncComponent(() => import('../../components/FormularioTransferenciaDeResponsavel/FormTransferenciaResponsavel.vue')),
    TrfDetalhesProcessos: defineAsyncComponent(() => import('../../components/DetalhesProcessos')),
    TrfDashboardTotalizadoresCards: defineAsyncComponent(() => import('../../components/DashboardTotalizadoresCards')),
    ELegalizeModalListaProcessos: defineAsyncComponent(() => import('./ModalListaProcessos/index.vue')),
    TrfDropdownButton: defineAsyncComponent(() => import('../../components/DropdownButton/index.vue')),
    TrfFilter: defineAsyncComponent(() => import('../../components/Filter/index.vue')),
    TrfParalisarFormComponent: defineAsyncComponent(() => import("../../views/Dashboard/components/paralisarFormComponent.vue")),
    TrfSelect: defineAsyncComponent(() => import('../../components/Select/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('../../components/ToolbarTextEditor/index.vue')),
    TrfModalAlterarData: defineAsyncComponent(() => import("../../components/Modal/TrfModalAlterarData.vue"))
  },
  props: {
    statusTela: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      status: this.statusTela,
      isModalDetalhesFaseAtivo: false,
      detalhesFase: null,
      faseIdSelecionada: null,
      tituloModalDetalhesFase: '',
      modalFormulario: {
        isAtivo: false,
        isEdicao: false,
        isLoading: false,
        labelConfirma: '',
        titulo: '',
        acaoConfirma: () => {},
        acaoCancela: () => {},
        processo: {
          titulo: '',
          labelConfirma: '',
          acaoConfirma: () => {},
          acaoCancela: () => {},
        }
      },
      isModalTransferenciaAtivo: false,
      modalListaProcessos: {
        filtro: {
          "sort[ASC]": "prazoEntrega",
          status: null
        },
        titulo: "",
        isAtivo: false
      },
      dados: {
        processos: []
      },
      fasesIds: [],
      processosIds: [],
      dataSourceProcessos: {
        columns: [
          {
            name: 'nome',
            label: 'Negócio',
            style: 'width:25%;vertical-align:middle;'
          },
          {
            name: 'andamento',
            label: 'Andamento',
            style: 'width:10%;vertical-align:middle;',
          },
          {
            name: 'dataInicial',
            label: 'Data de início',
            style: 'width:11%;vertical-align:middle;'
          },
          {
            name: 'dataPrevisaoConclusao',
            label: 'Prazo final',
            style: 'width:10%;vertical-align:middle;'
          },
          {
            name: 'responsavel',
            label: 'Responsável',
            style: 'width:14%;vertical-align:middle;'
          },
          {
            name: 'dataConclusao',
            label: 'Data de conclusão',
            style: 'width:12%;vertical-align:middle;'
          },
          {
            name: 'status',
            label: 'Status',
            style: 'width:18%; white-space:nowrap; vertical-align:middle;',
            classe: true,
          }
        ],
        selected: null,
        itens: [],
        save: (item) => console.log('[save] ' + item),
        filter: () => this._carregarListagem(),
        select: (item) => {
          if (!this.permissoesTarefas || this.permissoesTarefas.Editar) {
            this.openModalEdicao(item);
          }
        },
        delete: (item) => this.excluir(item),
        preDelete: (item) => this.atribuirTextoExclusao(item),
        loadMore: null,
        shareResponsavelEDepartamento: (item) => {
          this.$refs.formTransferenciaResponsavel.filterResponsaveisOptions(item.departamentoId)
          this.processosIds.push(item.id)
          this.abrirModalTransferirResponsavel(item)
        },
        concluirTarefa: (item) => this.doConcluir(item),
        reabrirTarefa: (item) => this._carregarCards()
      },
      processosSelecionados: [],
      showGlobalLoader: false,
      loading: {
        cadastrando: false
      },
      paginaTabela: 1,
      totalTabela: 0,
      limiteTabela: 10,
      permissoesLegalize: pessoaLogada.getPermissoes("eLegalize"),
      permissoesTarefas: pessoaLogada.getPermissoes("Tarefas"),
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      isOperadorAdmin: pessoaLogada.current.Administrador,
      hideButtons: false,
      statusTabela: '',
      mensagemExclusaoDeAcordoComTipoDeProcesso: '',
      isModalTransferirResponsavelActive: false,
      responsavelProcessoId: null,
      objetoTransferenciaResponsavel: {},
      loadingConfirmarTransferencia: false,
      responsavelOptions: [],
      listaDepartamentos: [],
      operadorLogadoSuperAdmOuAdm: false,
      detalhesProcessos: null,
      isModalDetalhesProcessosAtivo: false,
      tituloModalDetalhesProcessos: "",
      cards: {
        aFazer: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "a-fazer"
        },
        atrasados: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "atrasado"
        },
        concluidos: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "concluido"
        },
        paralisados: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "paralisado"
        },
        aguardandoDados: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "aguardando-dados"
        },
        aguardandoConferencia: {
          isLoading: true,
          isOpening: false,
          quantidade: 0,
          tipo: "aguardando-conferencia"
        }         
      },
      opcoesNovoProcesso: [
        {
          nome: "Cadastrar negócio",
          icon: "mdi-plus",
          id:"btn-cadastrar-processo",
          acao: () => this.openModalCadastro()
        },
        {
          nome: "Cadastro de formulários",
          icon: "mdi-plus",
          id:"btn-cadastro-formulario",
          acao: () => this.openCadastroFormularios()
        }
      ],
      filterConfig: new ConfigFiltro(),
      filtro: {},
      invalidFilterConclusao: false,
      itemEmAcesso: null,
      isModalPausarAtivo: false,
      isModalContinuarAtivo: false,
      isBtnModalLoading: false,
      tituloModalContinuar: '',
      tituloModalPausar: '',
      processoParaEnvio: {},
      configsModalEnvioDoFormulario: {
        titulo: 'Enviar formulário',
        isModalEnvioDoFormularioAtivo: false,
        isAberturaPeloMaisAcoes: false,
        isFormularioEnviado: false,
        labelConfirma: "Sim",
        labelCancela: "Não",
        isBtnLoading: false
      },
      modalReenvioComAjustes: {
        ajustes: null,
        ajustesPlainText: null,
        isLoading: false,
        isAtivo: false,
        maxlength: 5000
      },
      templatesFormulario: [],
      loadingTemplatesFormulario: false,
      templateSelecionadoEnvio: null,
      isReenvio: false,
      isTemplateSelecionadoTouched: false,
      isAlterarDataActive: false,
      itemAlterarData: null
    };
  },
  computed: {
    tipLabelReenvio() {
      let count = this.modalReenvioComAjustes.maxlength;
      if(this.modalReenvioComAjustes.ajustesPlainText) {
        count -= this.modalReenvioComAjustes.ajustesPlainText.length;
      }
      return count + ` caracteres restantes`;
    },
    filtrosRequisicaoProcesso() {
      const objetoDeFiltro = {
        'sort[DESC]': 'id',
        pagina: this.paginaTabela || 1,
        limit: this.limiteTabela || 10,
        ...this.filtro
      };

      return objetoDeFiltro;
    },
    processosAsTableRows() {
      if (!Array.isArray(this.dados?.processos)) return [];
      const dados = []

      for (let processo of this.dados.processos) {
        const dataCriacaoFormatada = processo.dataCriacao? processo.dataCriacao.substr(0,10).replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1') : '---'
        const dataConclusaoFormatada = processo?.historicoTarefas?.dataConclusao ? processo?.historicoTarefas?.dataConclusao.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1') : '---'
        const dataPrevisaoConclusaoFormatada = processo?.dataPrevisaoConclusao? processo.dataPrevisaoConclusao.substr(0,10).replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1') : '---'
        const statusNome = processo?.historicoTarefas?.status?.nome? processo.historicoTarefas.status.nome : ''
        const processado = {
          id: processo.id,
          nome: processo.nomeNegocio,
          andamento: `${processo.porcentagem}%`,
          dataInicial: dataCriacaoFormatada,
          dataPrevisaoConclusao: dataPrevisaoConclusaoFormatada,
          responsavel: this.obterNomeResponsavel(processo?.historicoTarefas?.responsavelId),
          dataConclusao: dataConclusaoFormatada,
          status: statusNome == "Paralisada" ? "Paralisado" : statusNome,
          fases: processo?.historicoTarefas?.fases,
          isProcesso: processo.isProcesso,
          podeEnviarFormulario: processo.podeEnviarFormulario,
          historicoTarefaId: processo?.historicoTarefas?.id,
          departamentoId: processo?.historicoTarefas?.departamentoId,
          isAlgumaFaseParalisada: processo?.isAlgumaFaseParalisada,
          isAlgumaFaseConcluida: processo?.isAlgumaFaseConcluida,
          isAlgumaFaseEnviada: processo?.isAlgumaFaseEnviada,
          isFormularioJaEnviadoAoCliente: processo.isFormularioJaEnviadoAoCliente,
          formularioProcessoId: processo?.formularioProcesso?.id,
          opcoesTabela: this.getOpcoesTabela(processo),
          tipoDeProcessoId: processo.tipoDeProcessoId
        }
        
        dados.push(processado)
      }
      return dados
    },
    totalizadores() {
      return [
        {
          id: "card-aguardando-dados",
          tipo: this.cards.aguardandoDados.tipo, 
          nome: "Aguard. dados",
          quantidade: this.cards.aguardandoDados.quantidade,
          cor: "#547CAC",
          icone: "clock",
          isLoading: this.cards.aguardandoDados.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosAguardandoDados,
        },
        {
          id: "card-aguardando-conferencia",
          tipo: this.cards.aguardandoConferencia.tipo, 
          nome: "A conferir",
          quantidade: this.cards.aguardandoConferencia.quantidade,
          cor: "#c4b43c",
          icone: "exclamation",
          isLoading: this.cards.aguardandoConferencia.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosAguardandoConferencia,
          tooltip: 'Aguardando a conferência do usuário'
        },
        {
          id: "card-a-fazer",
          tipo: this.cards.aFazer.tipo, 
          nome: "A fazer",
          quantidade: this.cards.aFazer.quantidade,
          cor: "#5692E6",
          icone: "list",
          isLoading: this.cards.aFazer.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosAFazer
        },
        {
          id: "card-atrasado",
          tipo: this.cards.atrasados.tipo, 
          nome: "Atrasados",
          quantidade: this.cards.atrasados.quantidade,
          cor: "#E33B3C",
          icone: "triangle-exclamation",
          isLoading: this.cards.atrasados.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosAtrasados
        },
        {
          id: "card-paralisado",
          tipo: this.cards.paralisados.tipo, 
          nome:  "Paralisados",
          quantidade: this.cards.paralisados.quantidade,
          cor: "#666666",
          icone: "pause",
          isLoading: this.cards.paralisados.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosParalisados
        },
        {
          id: "card-concluido",
          tipo: this.cards.concluidos.tipo, 
          nome:  "Concluídos",
          quantidade: this.cards.concluidos.quantidade,
          cor: "#32AA45",
          icone: "check",
          isLoading: this.cards.concluidos.isLoading,
          isCardSempreVisivel: true,
          acao: this.listarProcessosConcluidos
        },
      ]
    },
    templateFormularioAsOptionList() {
      if (!this.templatesFormulario) return []
      const listaOptions = this.templatesFormulario.map(template => {
        return {
          label: template.nome,
          value: template.id
        }
      });
      return listaOptions
    },
    hasTokenIntegracaoWhatsapp() {
      return configuracoesStore.hasTokenIntegracaoWhatsapp;
    },
    responsavelOptionsFiltro() {
      let responsaveisTratados;
      if(!!!this.operadorLogadoSuperAdmOuAdm) {
        const responsavelLogadoUWD = acessoUtils.adquirirUWDDoUsuarioLogado();
        responsaveisTratados = this.responsavelOptions.filter(responsavel => {
          return responsavel.value == responsavelLogadoUWD;
        })
        let isPresent = false;
        this.responsavelOptions?.forEach((element) => {
          responsaveisTratados[0]?.idsDepartamentosResponsavel?.forEach((idDeDepartamento)=>{
            isPresent = element?.idDoResponsavelDoHistorico?.some(
              idDepartamentoHistorico => idDepartamentoHistorico == idDeDepartamento
            )
            if (isPresent) {
              if (responsaveisTratados[0].value != element.value) {
                responsaveisTratados.push(element)
              }
            }  
          });  
        });
      } else {
        responsaveisTratados = this.responsavelOptions;
      }
      return [
        { value: "sem responsavel", label: "Sem Responsável" },
        ...responsaveisTratados
      ];
    }
  },
  methods: {
    async importTemplateFormularioService() {
        const { templateFormularioService } = await import('../../service/template-formulario-service.js')
        return templateFormularioService
    },
    async importUsuarioService() {
      const { usuarioService } = await import(
        "../../service/usuario-service"
      );
      return usuarioService;
    },
    async importDepartamentoService() {
      const { departamentoService } = await import('../../service/departamento-service.js');
      return departamentoService;
    },
    async importProcessoService() {
      const { processoService } = await import('../../service/processo-service.js')
      return processoService
    },
    async importHistoricoService() {
      const { service } = await import('../Dashboard/service/historico-tarefas-service.js')
      return service
    },
    async importTotalizadorService() {
      const { legalizeTotalizadorService } = await import('../../service/legalize-totalizador-service.js')
      return legalizeTotalizadorService
    },
    hasPermissaoVisualizar() {
      return !this.permissoesLegalize || this.permissoesLegalize.Visualizar || this.isSuperAdm
    },
    hasPermissaoEditar() {
      return !this.permissoesLegalize || (this.permissoesLegalize.Visualizar && this.permissoesLegalize.Editar) || this.isSuperAdm
    },
    hasPermissaoExcluir() {
      return !this.permissoesLegalize || (this.permissoesLegalize.Visualizar && this.permissoesLegalize.Excluir) || this.isSuperAdm
    },
    getDataSourceFase(fases) {
      const dataSource = {
        columns: [
          {
            name: "nome",
            label: "Fase do negócio",
            style: "width:43%;vertical-align:middle;",
          },
          {
            name: "responsavel",
            label: "Responsável",
            style: "width:18%;vertical-align:middle;",
          },
          {
            name: "dataConclusao",
            label: "Data de conclusão",
            style: "width:16%;vertical-align:middle;",
          },
          {
            name: "status",
            label: "Status",
            style: "width:27%; white-space:nowrap;vertical-align:middle;",
            classe: true,
          },
        ],
        selected: null,
        itens: !!fases? fases : [],
        itensSelected: [],
        itensDisabled: [],
        filter: () => {},
        delete: (item) => this.excluir(item),
        shareResponsavelEDepartamento: (item) => {
          this.$refs.formTransferenciaResponsavel.filterResponsaveisOptions(item.departamentoId)
          this.fasesIds.push(item.id);
          this.processosIds.push(item.processoId);
          this.abrirModalTransferirResponsavel(item)
        },
        concluirTarefa: (item) => this.doConcluir(item),
        reabrirTarefa: (item) => this._carregarCards(),
        loadMore: null,
      };
      return dataSource;
    },
    getFasesAsTableRow(processoId, fases) {
      if (!Array.isArray(fases)) return [];
      fases.sort((a, b) => {
        if (a.ordem !== b.ordem) {
          return a.ordem - b.ordem;
        }
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;
        return 0;
      });
  
      const fasesAsTableRow = []
      for (let fase of fases) {
        const dataConclusaoFormatada = fase.dataConclusao? fase.dataConclusao.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1') : '---'
        const nomeStatus = fase.status.nome;
        const statusId = fase.status.id;
        const processado = {
          ...fase,
          responsavel: this.obterNomeResponsavel(fase.responsavelId),
          dataConclusao: dataConclusaoFormatada,
          status: nomeStatus,
          statusId: statusId,
          isFase: true,
          isAdmin: pessoaLogada.current.Administrador,
          isTarefaDoLegalize: true,
          processoId: processoId,
          isFaseProcesso: true
        }
        fasesAsTableRow.push(processado)
      }
      return fasesAsTableRow
    },
    setSelecaoTabela(selecao) {
      this.processosSelecionados = selecao;
    },
    setConfiguracaoModal(dados) {
      if(!dados) {
        this.setConfiguracaoModal(this.modalFormulario.processo);
        return;
      }

      for(const [key, value] of Object.entries(dados)) {
        this.modalFormulario[key] = value;
      }
    },
    setTemplateSelecionadoEnvio(id) {
      this.templateSelecionadoEnvio = id
    },
    doNavegarParaVisualizacaoDoFormulario(processo) {
      window.scrollTo(0,0);
      routerUtils._carregarNovaRota(`/elegalize/form/visualizar/${processo.formularioProcessoId}`);
    },
    async adquirirListaTemplates() {
      this.loadingTemplatesFormulario = true;
      try {
        const templateFormularioService = await this.importTemplateFormularioService();
        const templatesFormulario = await templateFormularioService.listar({
          "sort[ASC]": "nome", 
          pagina: 1, 
          limit: 999,
          tipoFormulario: tipoFormularioEnum.PROCESSO_ELEGALIZE.getId()
        })
        this.templatesFormulario = templatesFormulario.data;
      } catch (e) {
        console.error(e.message? e.message : e)
      }
      this.loadingTemplatesFormulario = false;
    },
    openModalEdicao(item) {
      this.modalFormulario.processo = {
        titulo: TITULO_MODAL_EDITAR,
        acaoConfirma: this.doEditarProcesso,
        acaoCancela: this.doFecharModalProcesso,
        labelConfirma: CONFIRMAR_MODAL_EDITAR
      };
      this.setConfiguracaoModal(this.modalFormulario.processo);

      this.modalFormulario.isAtivo = true;
      this.modalFormulario.isEdicao = true;

      this.changeScrollHtmlTagState('hidden');

      const processo = this.dados.processos.find(p => p.id == item.id);
      if(processo.formularioProcesso) {
         processo.formularioProcesso.empresa = {
          ...processo.empresa,
          numero: processo.empresa.enderecoNumero,
          complemento: processo.empresa.enderecoComplemento,
          estado: processo.empresa.uf,
          capitalSocial: processo.empresa.valorCapital
        };
         processo.formularioProcesso.anexos = processo.anexos;
      }     
      
      const modelProcesso = new ProcessoElegalize();
      modelProcesso.asModel(processo);

      modelProcesso.isAlgumaFaseConcluida = processo.isAlgumaFaseConcluida;
      modelProcesso.isAlgumaFaseParalisada = processo.isAlgumaFaseParalisada;
      this.$refs.eLegalizeForm.inicializarCampos(modelProcesso);
    },
    openModalCadastro() {
      this.modalFormulario.processo = {
        titulo: TITULO_MODAL_CADASTRAR,
        acaoConfirma: this.doCadastrarProcesso,
        acaoCancela: this.doFecharModalProcesso,
        labelConfirma: CONFIRMAR_MODAL_CADASTRAR
      };

      this.setConfiguracaoModal(this.modalFormulario.processo);

      this.modalFormulario.isAtivo = true;
      this.modalFormulario.isEdicao = false;

      this.changeScrollHtmlTagState('hidden');
    },
    openCadastroFormularios() {
      routerUtils._carregarNovaRota('/formularios');
    },
    doFecharModalProcesso() {
      this.setScrollSelectFluxoTop();
      this.$refs.eLegalizeForm.doReset();
      document.querySelector(".scroll-personalizado").scrollTo(0,0);
      this.changeScrollHtmlTagState('auto');
      this.modalFormulario.isAtivo = false;
    },
    doAbrirModalEnvioDoFormulario(detail, isAberturaPeloMaisAcoes) {
      this.isReenvio = detail.isFormularioJaEnviadoAoCliente;
      this.processoParaEnvio = isAberturaPeloMaisAcoes
        ? this.dados.processos.find((processo) => processo.id == detail.id)
        : detail;
        
      if(this.processoParaEnvio.tipoDeProcessoId != TipoDeProcessoEnum.LEGALIZACAO) {
        return;
      }

      if(detail.status == statusTarefas.obterTexto("aConferir")) {
        this.modalReenvioComAjustes.isAtivo = true;
        return;
      }

      this.setConfiguracoesDeAberturaModalEnvioDoFormulario(isAberturaPeloMaisAcoes);
    },
    doAbrirModalAlterarVencimento(item, event) {
      this.isAlterarDataActive = true
      this.itemAlterarData = item;
    },
    doFecharModalAlterarVencimento(event) {
      this.isAlterarDataActive = event;
    },
    doRecarregarListagemAlteracaoVencimento(event) {
      if(!event) return;
      this._carregarListagem()
      this._carregarCards()
    },
    closeModalEnvioDoFormulario() {
      this.templateSelecionadoEnvio = null;
      this.isReenvio = false;
      this.isTemplateSelecionadoTouched = false;
      this.configsModalEnvioDoFormulario.isModalEnvioDoFormularioAtivo = false;
      this.limparSelectEValidacaoModalEnvioForm();
      if(!this.configsModalEnvioDoFormulario.isAberturaPeloMaisAcoes && !this.configsModalEnvioDoFormulario.isFormularioEnviado) {
        this._carregarListagem(true);
        this._carregarCards();
      }
      this.configsModalEnvioDoFormulario.isFormularioEnviado = false;
      this.processoParaEnvio = {};
    },
    doFecharModalReenvioComAjustes() {
      this.isReenvio = false;
      this.processoParaEnvio = {};
      this.modalReenvioComAjustes = {
        ...this.modalReenvioComAjustes,
        ajustes: null,
        ajustesPlainText: null,
        isLoading: false,
        isAtivo: false
      }
    },
    async doFecharModalEnvioDoFormulario() {
      this.templateSelecionadoEnvio = null;
      this.isReenvio = false;
      this.isTemplateSelecionadoTouched = false;
      if (!this.configsModalEnvioDoFormulario.isAberturaPeloMaisAcoes) {
        const service = await this.importProcessoService();
        service.enviarProgresso(this.processoParaEnvio.id);
      }
      this.closeModalEnvioDoFormulario();
    },
    setConfiguracoesDeAberturaModalEnvioDoFormulario(isAberturaPeloMaisAcoes) {
      this.configsModalEnvioDoFormulario.isAberturaPeloMaisAcoes = isAberturaPeloMaisAcoes;
      this.configsModalEnvioDoFormulario.isModalEnvioDoFormularioAtivo = true;
    },
    async doEnviarFormulario() {
      if(!this.isReenvio && !this.templateSelecionadoEnvio) {
        toastUtils.dangerToast("Selecione um formulário para prosseguir!")
        this.isTemplateSelecionadoTouched = true
        return;
      }
      try {
        this.configsModalEnvioDoFormulario.isBtnLoading = true;
        const processoService = await this.importProcessoService();
        const requestBody = {
          processoId: this.processoParaEnvio.id,
        }
        if (!this.isReenvio) {
          requestBody.templateFormularioId = this.templateSelecionadoEnvio;
        }
        await processoService.enviarFormulario(requestBody);
        this.configsModalEnvioDoFormulario.isFormularioEnviado = true;
        toastUtils.successToast("Formulário enviado com sucesso!")
        this.closeModalEnvioDoFormulario();
        this._carregarListagem(true);
        this._carregarCards();
      } catch (e) {
        console.warn(`WARN: ${e}`)
      } finally {
        this.configsModalEnvioDoFormulario.isBtnLoading = false;
      }
      this.modalFormulario.isAtivo = false
      this.templateSelecionadoEnvio = null;
      this.isReenvio = false;
      this.isTemplateSelecionadoTouched = false;
      this.limparSelectEValidacaoModalEnvioForm();
    },

    async doEnviarFormularioComAjustes() {
      try {
        this.modalReenvioComAjustes.isLoading = true;
        const processoService = await this.importProcessoService();
        const requestBody = {
          processoId: this.processoParaEnvio.id,
          ajustes: this.modalReenvioComAjustes.ajustes,
          ajustesPlainText: this.modalReenvioComAjustes.ajustesPlainText
        }
        await processoService.enviarFormulario(requestBody);
        toastUtils.successToast("Formulário reenviado com sucesso!")
        this._carregarListagem(true);
        this._carregarCards();
      } catch (e) {
        console.warn(`WARN: ${e}`)
      } finally {
        this.doFecharModalReenvioComAjustes();
      }
    },

    changeScrollHtmlTagState(value) {
      document.documentElement.style.overflow = value;
    },

    setScrollSelectFluxoTop() {
      document.querySelector("#processo-form-legalizacao-fluxo .multiselect-dropdown.is-hidden").className = 'multiselect-dropdown'
      document.querySelector("#processo-form-legalizacao-fluxo .multiselect-dropdown").scrollTo(0,0);
      document.querySelector("#processo-form-legalizacao-fluxo .multiselect-dropdown").className = 'multiselect-dropdown is-hidden'
    },

    async montarObjetoTransferenciaResponsavelTarefa(value) {
      this.objetoTransferenciaResponsavel = {
        usuarioId: value.responsavelId,
        usuarioNome: value.responsavelNome,
        fasesIds: this.fasesIds,
        processosIds: this.processosIds,
        isTransferenciaIndividual: true
      }
    },
    async transferirResponsavel() {
      this.loadingConfirmarTransferencia = true;
      const processoService = await this.importProcessoService();
      const response = await processoService.transferirResponsavel(this.objetoTransferenciaResponsavel);
      
      let mensagemToast = "Negócio transferido com sucesso!";

      if (this.objetoTransferenciaResponsavel.fasesIds.length > 0) {
        mensagemToast = "Tarefa transferida com sucesso!"
      }
      
      if (response.ok) {
        toastUtils.successToast(mensagemToast);
      }
      this.loadingConfirmarTransferencia = false;
      await this.fecharModalTransferirResponsavel(); 
    },
    async _carregarCards() {
      for (const [key, ] of Object.entries(this.cards)) {
        this.cards[key].isLoading = true;
      }

      const totalizador = await this.importTotalizadorService();
      const cards = await totalizador.countForCards(this.filtro);
      for (const [key, value] of Object.entries(cards)) {
        this.cards[key].quantidade = value;
        this.cards[key].isLoading = false;
      }
    },
    async _carregarListagem(reiniciarPaginacao) {
      this.showGlobalLoader = true;

      try {
        const processoService = await this.importProcessoService();
        if (!!reiniciarPaginacao) {
          this.paginaTabela = 1;
        }
        let listaDeProcessos = await processoService.listar(this.filtrosRequisicaoProcesso);
        if (
          !!!reiniciarPaginacao &&
          this._validarNecessidadeDeTrocaDePagina(parseInt(listaDeProcessos.totalDePaginas), this.paginaTabela)
        ) {
          this.paginaTabela = listaDeProcessos.totalDePaginas;
          this._carregarListagem();
          return;
        }

        this.totalTabela = parseInt(listaDeProcessos.totalDeItens);

        if (this.totalTabela === 0) {
          this.statusTabela = "is-empty";
        } else {
          this.dados.processos = listaDeProcessos.data;
          this.statusTabela = "";
        }
      } catch (e) {
        this.statusTabela = "is-danger";
      }
      this.showGlobalLoader = false;
    },

    _validarNecessidadeDeTrocaDePagina(totalDePaginas, pagina) {
      if (totalDePaginas == 0) return false;
      return totalDePaginas < pagina;
    },
    async filtrar() {
      if(this.invalidFilterConclusao) {
        toastUtils.dangerToast("Filtro de data de conclusão invalido!")
        return
      }
      this.statusTabela = 'is-loading';
      this.dados.processos = [];
      this.paginaTabela = 1;

      this._carregarListagem();
      this._carregarCards();
    },
    async nextPagina(pagina) {
      this.paginaTabela = pagina;

      this._carregarListagem();
    },
    async nextLimite(limite) {
      this.limiteTabela = limite;
      this._carregarListagem();
    },
    updatePagina(pagina) {
      this.paginaTabela = pagina;
      this._carregarListagem();
    },
    updateLimite(limite) {
      this.limiteTabela = limite;
    },
    async doCadastrarProcesso() {
      try {
        this.modalFormulario.isLoading = true;
        const processo = await this.$refs.eLegalizeForm.doSalvar();
        if(!processo) return;
        
        if(processo.tipoDeProcessoId == TipoDeProcessoEnum.LEGALIZACAO) {
          this.doCadastrarComFormulario(processo);
          return;
        }

        this.doCadastrarSemFormulario(processo);
        this.doFecharModalProcesso();
      } catch (e) {
        console.warn(`WARN: ${e}`);
        toastUtils.dangerToast("Não foi possível cadastrar o processo");
      } finally {
        this.modalFormulario.isLoading = false;
      }
    },
    async doCadastrarSemFormulario(processo) {
      const service = await this.importProcessoService();
      service.enviarProgresso(processo.id);

      this._carregarListagem(false);
      this._carregarCards();
    },
    doCadastrarComFormulario(processo) {
      this.doFecharModalProcesso();
      this.doAbrirModalEnvioDoFormulario(processo, false);
    },
    async doEditarProcesso() {
      try {
        this.modalFormulario.isLoading = true;
        const processoEditado = await this.$refs.eLegalizeForm.doEditar();
        this.modalFormulario.isLoading = false;
        
        if(processoEditado != null) {
          this.doFecharModalProcesso();
          this.filtrar();
        }
      } catch (e) {
        console.warn(`WARN: ${e}`)
        this.modalFormulario.isLoading = false;
        toastUtils.dangerToast("Não foi possível editar o processo")
      }
    },
    atribuirTextoExclusao(processo) {
      this.mensagemExclusaoDeAcordoComTipoDeProcesso = `Deseja excluir o negócio <strong>${processo.nome}</strong>?` + 
          `<br/><br/><strong>Atenção:</strong> Ao clicar em confirmar, a tarefa e fases correspondentes a este negócio também serão excluídas.`
    },
    async excluir(processo) {
      try {
        const processoService = await this.importProcessoService();
        const resposta = await processoService.excluir(processo);

        if (resposta.ok) {
          toastUtils.successToast('Negócio excluído com sucesso!');
          const itemIndex = this.processosAsTableRows.findIndex((item) => item.id === processo.id);
          this.processosAsTableRows.splice(itemIndex, 1);
          this._carregarListagem(false);
          this._carregarCards();
        }
      } catch (e) {
        toastUtils.dangerToast('Erro ao tentar excluir o negócio!');
        console.error(e);
      }
    },
    async abrirModalTransferirResponsavel(item) {
      this.$refs.formTransferenciaResponsavel.atribuirResponsavelPadrao(item);
      this.isModalTransferenciaAtivo = true;
    },

    async fecharModalTransferirResponsavel() {
      this.fasesIds = [];
      this.processosIds = [];
      this.$refs.formTransferenciaResponsavel.doReset();
      this.isModalTransferenciaAtivo = false;
      await this._carregarListagem(true);
    },
    async doConcluir(processo) {
      try {
        const processoService = await this.importProcessoService();
        const historicoService = await this.importHistoricoService();
        let motivoConclusao = document.querySelector("#motivo-conclusao")?.value;

        let item = processo;
        let resposta;

        if (item.isFase) {
          resposta = await historicoService.concluir(item.historicoTarefaId, item.id, motivoConclusao);
        } else {
          resposta = await processoService.concluir(item.id, motivoConclusao);
        }

        if (!resposta) {
          return;
        }

        if(item.notificarConclusao) {
          toastUtils.infoToast('Notificação enviada com sucesso!');
        }

        this._carregarListagem(false);
        this._carregarCards();
      } catch (e) {
        toastUtils.dangerToast('Erro ao tentar concluir o negócio!');
        console.error(e);
      }
    },
    doAbrirModalTimelineProcesso(detail) {
      const processoSelecionado = this.dados.processos.find((processo) => {
        return processo.id == detail.id;
      });
      if (!!processoSelecionado) {
        this.detalhesProcessos = processoSelecionado;
        this.tituloModalDetalhesProcessos = this.detalhesProcessos.nomeNegocio;
        this.isModalDetalhesProcessosAtivo = true;
      }
    },
    doFecharModalDetalhesProcessos() {
      this.isModalDetalhesProcessosAtivo = false;
      this.tituloModalDetalhesProcessos = '';
      this.detalhesProcessos = null;
    },
    recarregarProcesso() {
      this._carregarListagem(false);
    },
    doAbrirModalTimelineFase(processo, fase) {
      const processoCompleto = this.dados.processos.find(p => p.id === processo.id);
      
      if (processoCompleto) {
        this.detalhesFase = processoCompleto;
        this.faseIdSelecionada = fase.id;
        this.tituloModalDetalhesFase = `${processoCompleto.nomeNegocio} - Fase: ${fase.nome}`;
        this.isModalDetalhesFaseAtivo = true;
      }
    },
    doFecharModalDetalhesFase() {
      this.isModalDetalhesFaseAtivo = false;
      this.tituloModalDetalhesFase = '';
      this.detalhesFase = null;
      this.faseIdSelecionada = null;
    },
    async listarResponsaveis() {
      const usuarioService = await this.importUsuarioService();
      this.responsavelOptions = await usuarioService.listarResponsaveis();
      return this.responsavelOptions;
    },
    async buscarOperadorLogado() {
      const operador = await acessoUtils.adquirirOperadorLogado();
      this.operadorLogadoSuperAdmOuAdm = acessoUtils.isOperadorAdmin(operador) || acessoUtils.isOperadorSuperAdm(operador);
    },
    obterNomeResponsavel(responsavelId) {
      if (!responsavelId) return '---';
      const responsavel = this.responsavelOptions.find(r => r.value == responsavelId);
      return responsavel?.label || '---';
    },
    async listarDepartamentos() {
      const departamentoService = await this.importDepartamentoService();
      this.listaDepartamentos = await departamentoService.listar();
      return this.listaDepartamentos;
    },
    async listarProcessosAFazer() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.aFazer.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.aFazer.isOpening = true;
      this.toggleCardHidden(this.cards.aFazer.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.PENDENTE;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status a fazer";
      this.toggleCardHidden(this.cards.aFazer.tipo);
      this.cards.aFazer.isOpening = false;

      this.modalListaProcessos.isAtivo = true;
    },
    async listarProcessosAtrasados() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.atrasados.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.atrasados.isOpening = true;
      this.toggleCardHidden(this.cards.atrasados.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.ATRASADA;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status atrasado";
      this.toggleCardHidden(this.cards.atrasados.tipo);
      this.cards.atrasados.isOpening = false;

      this.modalListaProcessos.isAtivo = true;
    },
    async listarProcessosConcluidos() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.concluidos.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.concluidos.isOpening = true;
      this.toggleCardHidden(this.cards.concluidos.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.CONCLUIDO;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status concluído";
      this.toggleCardHidden(this.cards.concluidos.tipo);
      this.cards.concluidos.isOpening = false;

      this.modalListaProcessos.isAtivo = true;
    },
    async listarProcessosParalisados() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.paralisados.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.paralisados.isOpening = true;
      this.toggleCardHidden(this.cards.paralisados.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.PARALISADA;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status paralisado";
      this.toggleCardHidden(this.cards.paralisados.tipo);
      this.cards.paralisados.isOpening = false;
      this.modalListaProcessos.isAtivo = true;
    },
    async listarProcessosAguardandoDados() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.aguardandoDados.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.aguardandoDados.isOpening = true;
      this.toggleCardHidden(this.cards.aguardandoDados.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.AGUARDANDO_DADOS;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status aguardando dados";
      this.toggleCardHidden(this.cards.aguardandoDados.tipo);
      this.cards.aguardandoDados.isOpening = false;
      this.modalListaProcessos.isAtivo = true;
    },
    async listarProcessosAguardandoConferencia() {
      if(this.isAnyCardLoadingOrOpening()) return;
      if(this.cards.aguardandoConferencia.quantidade == 0) {
        this.toastSemProcessos();
        return;
      }
      this.cards.aguardandoConferencia.isOpening = true;
      this.toggleCardHidden(this.cards.aguardandoConferencia.tipo);

      this.modalListaProcessos.filtro.status = statusEnum.AGUARDANDO_CONFERENCIA;
      this.modalListaProcessos.filtro = {
        ...this.filtro,
        ...this.modalListaProcessos.filtro
      }
      await this.$refs.modalListaProcessos.listarDados(true);

      this.modalListaProcessos.titulo = "Processos com status aguardando conferência";
      this.toggleCardHidden(this.cards.aguardandoConferencia.tipo);
      this.cards.paralisados.isOpening = false;
      this.modalListaProcessos.isAtivo = true;

    },
    toastSemProcessos() {
      toastUtils.infoToast("Não há processos a serem exibidos.")
    },
    toggleCardHidden(tipo) {
      const loader = document.getElementById(`loading-card-${tipo}`);
      loader.classList.toggle('is-hidden');
    },
    isAnyCardLoadingOrOpening() {
      const isLoading = this.cards.aFazer.isLoading
        || this.cards.atrasados.isLoading
        || this.cards.concluidos.isLoading; 
      const isOpening = this.cards.aFazer.isOpening
        || this.cards.atrasados.isOpening
        || this.cards.concluidos.isOpening;
      return isLoading || isOpening;
    },
    fecharModalListaProcessos() {
      for (const [key, ] of Object.entries(this.cards)) {
        this.cards[key].isOpening = false;
        this.cards[key].isLoading = false;
      }
      this.modalListaProcessos.isAtivo = false;
    },
    async inicializarFiltro() {

      const textFiltro = defaultIlikeTextField('nome_negocio', 'nomeNegocioFiltro', "Nome do negócio", "Digite...")

      const buttonSelectorFiltro = defaultButtonSelectorIntervalField('periodo', 'intervaloFiltro')
      buttonSelectorFiltro.configuracoesDeInput.options[0].isSelected = false
      buttonSelectorFiltro.configuracoesDeInput.callbackFn = this._tratarIntervaloButton

      const campoBotao = defaultButtonFiltrar('buttonFiltrar', "buttonFiltrar", async () => {await this.filtrar()})

      const selectResponsavel = defaultSelectResponsavelField('responsavelId', 'select-responsavel-filtro', 'Responsável', this.responsavelOptionsFiltro)

      const checkboxFields = defaultCheckboxFieldsStatusFilter('status', 'checkbox-fields-status-filtro')

      const periodoFiltro = defaultPeriodoDataConclusaoField('dataConclusao', 'periodoConclusaoFiltro', 'Data de conclusão')
      periodoFiltro.configuracoesDeInput.callbackFn = this._tratarIntervaloPeriodo
      this.filterConfig.options = [
        textFiltro,
        buttonSelectorFiltro,
        campoBotao,
        selectResponsavel,
        checkboxFields
      ]

      this.filterConfig.advancedOptions = [
        periodoFiltro,
      ]

      await this.$nextTick()
    },
    _tratarIntervaloButton(value, configuration, ref) {
      if (!value || !ref) return
      
      if (!!value.dataInicial || !!value.dataFinal) {
        const periodoInputSelector = this.filterConfig.advancedOptions[0]?.configuracoesDeCampo.id
        ref.$emit('clear', periodoInputSelector)
      }
    },
    _tratarIntervaloPeriodo(value, configuration, ref) {
      if (!ref) return
      if (value && (!!value.dataInicial || !!value.dataFinal)) {
        const optionButtonSelect = this.filterConfig.options[1]?.configuracoesDeCampo.id
        ref.$emit('clear', optionButtonSelect)
      } else if(!value || Object.values(value).every(v => !v)) {
        ref.$emit('send-value', null, this.filterConfig.options[1]?.configuracoesDeCampo.id)
      }
    },
    isFiltroConclusaoValido(valor) {
      if (!valor.dataConclusao) return true;

      const dataInicialNaoExiste = !valor.dataConclusao["dataConclusao[ge]"] && !!valor.dataConclusao["dataConclusao[le]"];
      const dataFinalNaoExiste = !!valor.dataConclusao["dataConclusao[ge]"] && !valor.dataConclusao["dataConclusao[le]"];
      const dataFinalIsMenorQueInicial = new Date(valor.dataConclusao["dataConclusao[le]"]) < new Date(valor.dataConclusao["dataConclusao[ge]"]);
      return !dataInicialNaoExiste & !dataFinalNaoExiste & !dataFinalIsMenorQueInicial
    },
    setQuery(valor) {
      // É feito um clone do valor para tratar pois ele chega aqui ainda com reatividade no
      // componente original.
      let valorLocal = {...valor}
      if(!this.isFiltroConclusaoValido(valorLocal)) {
        this.invalidFilterConclusao = true
      } else {
        this.invalidFilterConclusao = false
      }
      
      const isSemResponsavel = valorLocal.responsavelId === "sem responsavel";
      
      valorLocal = clearInvalidIntervals(valorLocal)
      valorLocal = clearFilter(valorLocal)
      
      if (isSemResponsavel) {
        delete valorLocal.responsavelId;
        valorLocal["responsavelId[is]"] = null;
      }
      
      this.filtro = valorLocal
    },
    paralisarProcesso(item, evento) {
      this.abrirModalPausar(item)
    },
    continuarProcesso(item, evento) {
      this.abrirModalContinuar(item)
    },
    abrirModalPausar(item) {
      this.tituloModalPausar = "Paralisar negócio"
      if (item.isFase) {
        this.tituloModalPausar = "Paralisar fase"
      }
      this.itemEmAcesso = item
      this.isModalPausarAtivo = true
    },
    doParalisarProcesso() {
      this.isBtnModalLoading = true
      this.$refs.paralisarForm.doAction()
    },
    fecharModalPausar() {
      this.$refs.paralisarForm.doCancel()
      this.itemEmAcesso = null
      this.isModalPausarAtivo = false
      this.isBtnModalLoading = false
    },
    abrirModalContinuar(item) {
      this.tituloModalContinuar = "Continuar negócio"
      if (item.isFase) {
        this.tituloModalContinuar = "Continuar fase"
      }
      this.itemEmAcesso = item
      this.isModalContinuarAtivo = true
    },
    async processoParalisadoCallBack() {
      this.fecharModalPausar(); 
      await this.$nextTick();
      await this._carregarCards();
      await this._carregarListagem(true)
    },
    setBtnModalLoading(loadingStatus) {
      this.isBtnModalLoading = loadingStatus
    },
    async doContinuarProcesso() {
      this.isBtnModalLoading = true
      try {
        if (!this.itemEmAcesso) throw new Error("Item da ação não encontrado");
        const historicoId = this.itemEmAcesso.historicoTarefaId? this.itemEmAcesso.historicoTarefaId : this.itemEmAcesso.id;
        const faseId = this.getFaseId(this.itemEmAcesso);
        const service = await this.importHistoricoService();
        await service.continuarHistorico(historicoId, faseId,this.itemEmAcesso?.isProcesso);
        toastUtils.successToast(this.getSuccessToastMessage(this.itemEmAcesso));
        this.fecharModalContinuar();
        this._carregarListagem(true);
        await this._carregarCards();
      } catch (e) {
        console.warn(e);
        toastUtils.dangerToast(this.getDangerToastMessage(this.itemEmAcesso));
      }
      this.isBtnModalLoading = false
    },
    getObjectMessageToast(item) {
      let objetoAlterado = "Tarefa";
      let genero = "a";

      if (item?.isProcesso) {
        objetoAlterado = "Negócio";
        genero = "o";
      } 

      if (item?.isFase) {
        objetoAlterado = "Fase";
      }

      return {objetoAlterado, genero};
    },
    getSuccessToastMessage(item) {
      let objectMessageToast = this.getObjectMessageToast(item);

      return `${objectMessageToast.objetoAlterado} continuad${objectMessageToast.genero} com sucesso!`
    },
    getDangerToastMessage(item) {
      let objectMessageToast = this.getObjectMessageToast(item);

      objectMessageToast.objetoAlterado = objectMessageToast.objetoAlterado.toLowerCase();

      return `Não foi possível continuar com ${objectMessageToast.genero} ${objectMessageToast.objetoAlterado}!`;
    },
    fecharModalContinuar() {
      this.isModalContinuarAtivo = false
      this.isBtnModalLoading = false
    },
    getFaseId(item) {
        if (item?.isFase) {
            if (item?.processoId) {
                return item.id;
                }
            return item.faseId;
        }
    },
    getOpcoesTabela(processo) {
      let hint = '';

      const isParalisado = processo.historicoTarefas.status.id == parseInt(statusEnum.PARALISADA);
      const isConcluido = processo.historicoTarefas.status.id == parseInt(statusEnum.CONCLUIDO);

      if(isParalisado) {
        hint = "Paralisado";
      }

      if(isConcluido) {
        hint = "Concluído";
      }

      return {
        editar: {
          disabled: isParalisado || isConcluido,
          disabledHint: 'Processo com status "'+hint+'" não pode ser editado.'
        }
      }
    },
    limparSelectEValidacaoModalEnvioForm() {
      this.$refs.selectTemplateEnvio?.limparSelect();
      this.$refs.selectTemplateEnvio?.limparValidacao();
    },
    doChangeAjustesText(value) {
      const plainText = this.$refs.modalReenvioComAjustesText.getValueAsText();
      if(plainText.length > this.modalReenvioComAjustes.maxlength) {
        return;
      }

      this.modalReenvioComAjustes.ajustes = value;
      this.modalReenvioComAjustes.ajustesPlainText = this.$refs.modalReenvioComAjustesText.getValueAsText();
    },
    getTextoParaModalDeEnvio() {
      let processo = this.processoParaEnvio;

      if (this.configsModalEnvioDoFormulario.isAberturaPeloMaisAcoes && this.hasTokenIntegracaoWhatsapp && processo.pessoaContatoWpp) {
        return `Deseja enviar o formulário por e-mail e WhatsApp para a pessoa de contato da abertura do negócio <strong>${processo.nomeNegocio}</strong>?`;
      }

      if (this.configsModalEnvioDoFormulario.isAberturaPeloMaisAcoes) {
        return `Deseja enviar o formulário por e-mail para a pessoa de contato da abertura do negócio <strong>${processo.nomeNegocio}</strong>?`;
      }

      if (this.hasTokenIntegracaoWhatsapp && processo.pessoaContatoWpp) {
        return `Deseja enviar um formulário para preenchimento dos dados da empresa por e-mail e WhatsApp à pessoa de contato <strong>${processo.pessoaContatoNome}</strong>?`;
      }

      return `Deseja enviar um formulário para preenchimento dos dados da empresa por e-mail à pessoa de contato <strong>${processo.pessoaContatoNome}</strong>?`;
    },

  },
  async created() {
    await this.buscarOperadorLogado();
    camposEnderecoStore.adquirirTodosOsCampos();
    camposSocioStore.adquirirTodosOsCampos();
    await this.adquirirListaTemplates();
  },
  async mounted() {
    if (!!!this.permissoesLegalize) {
      this.permissoesLegalize = this.permissoesTarefas;
    }
    
    await Promise.all([
      this.listarResponsaveis(),
      this.listarDepartamentos()
    ]);

    await this.inicializarFiltro();

    await this._carregarListagem()

    this._carregarCards();
  }
};
</script>

<style lang="scss" scoped>
.error-message {
  font-size: 0.75rem;
  margin-top: -12px;
}
.multiselect-econtador {
  margin: 0;
}

#btn-incluir-dados {
  margin-right: 5px;
}

.btn-container {
  @media screen and (max-width: 600px) {
    margin-right: 0;
  }

  @media screen and (min-width: 900px) {
    width: 150px;
    margin-right: auto;
  }
}
</style>

<style lang="scss">
.tabela-fase-branca table tr {
    background:#FFF!important;
    &:hover {
      background: hsl(0deg, 0%, 96%)!important;
    }
  }
  table {
    .is-toggle-action {
      position:relative;
      input[type=checkbox] {
        opacity:0;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        pointer-events: none;
      }
    }
    & > tr, & > tbody > tr, & > thead > tr {
      & + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:0;
          overflow:hidden;
          padding-top:0;
          padding-bottom:0;
          margin-top:0;
          margin-bottom:0;
          transition: overflow 0s ease-out 0.35s, 0.35s ease-out 0s;
        }
      }
      &.is-toggled + .is-togglable-row {
        tr, th, td, th  > *, td > * {
          max-height:1000vh;
          overflow:visible;
          transition: overflow 0s ease-in 0.35s, 0.35s ease-in 0s;
        }
      }
    }
  }
  #modal-processo,#modal-envio-formulario,#modal-reenvio-formulario-com-ajustes {
    .modal-card {
      width:700px;
      max-width:98%;
      .modal-card-body {
        padding: 1rem 2.25rem;
        overflow: auto;
      }
    }
  }
  </style>